import Select from "react-select";
import { useMemo } from "react";

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: "#A6A6A6",          // darker border
        borderWidth: "2px",            // thicker border
        boxShadow: "none",            // remove blue glow
        "&:focus": {
            borderColor: "#FD64C3"         // even darker on hover
        }
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "#000"
    })
};

function CustomerDropdown({ customers = [], agentId, setField, selectedValue }) {
    const options = useMemo(() => {
        const id = Number(agentId);

        const assigned = customers
            .filter(c => c.assignedAgent?.id === id)
            .map(c => ({ value: c.id, label: c.name }));

        const unassigned = customers
            .filter(c => c.assignedAgent?.id !== id)
            .map(c => ({ value: c.id, label: c.name }));

        return [
            {
                label: "Assigned Customers",
                options: assigned
            },
            {
                label: "Other Customers",
                options: unassigned
            }
        ];
    }, [customers, agentId]);


    return (

        <Select
            options={options}
            placeholder="Please select..."
            isSearchable
            styles={customStyles}
            onChange={(selectedOption) => setField("customerId", selectedOption ? selectedOption.value : 0)}
            value={options.flatMap(g => g.options).find(o => o.value === Number(selectedValue))}
        />

    );

    
}

export default CustomerDropdown;